import { h } from 'preact'
import styles from './LogoSection.module.css'
import { useCustomContext } from '../../lib/context'

//const vmLogoBig = require('../../static/vm-logo-big.svg').default

export function LogoSection() {
  const context = useCustomContext()
  const handleClick = (event) => {
    if (!context) return
    const anchor = event.target.closest('a')
    if (!anchor) return
    context.sendGaEvent({ eventAction: 'click', eventLabel: anchor.getAttribute('href') })
  }
  return (
    <div class={styles['dh-fotball-banner__logoSection']}>
      <div class={styles['dh-fotball-banner__logoSection-nologo']}>FIFA Fotball-VM</div>
      <div class={styles['dh-fotball-banner__logoSection-links']}>
        <a onClick={handleClick} href="https://resultater.nrk.no/video">
          Video
        </a>
        <a onClick={handleClick} href="https://resultater.nrk.no/">
          Kampoversikt
        </a>
      </div>
    </div>
  )
}
